<template>
  <div class="downLoad">
  </div>
</template>

<script>
import { isiOS } from "../utils/util";

export default {
    name:"downLoad",
    data(){
        return{

        }
    },
    created(){
        var num=this.$route.query.num
   
         if (isiOS()) {
        //ios
        if (num == 1) {
          //国内版
          window.location.href="https://apps.apple.com/app/id1609019773"
        } else {
          window.location.href="https://apps.apple.com/app/id1518354131"
          //国际版
        }
      } else{
        //android

        if (num == 1) {
          //国内版
           window.location.href="https://cn-android-apk-release.oss-cn-shanghai.aliyuncs.com/yanhejiankangguanjia.apk"
        } else {
          window.location.href="https://play.google.com/store/apps/details?id=com.health.yanhenew"
     
          //国际版
        }
      }
    }

}
</script>

<style>

</style>